import { useRoutes } from "react-router-dom";
import "./App.less";
import { routes } from "@route";

function App() {
	const element = useRoutes(routes);
	return <div>{element}</div>;
}

export default App;
